export default __webpack_public_path__ + "static/media/Felix.c2453d38.jpeg";